/* HUMANS ARE MAGICIANS — small, optional enhancements.
   The site works fully without this file. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = document.documentElement.classList.contains('shopify-design-mode');

  /* Gentle reveal for content below the fold. Content already on screen at load is never hidden. */
  function setupReveal(root) {
    if (reduceMotion || inEditor || !('IntersectionObserver' in window)) return;
    var items = (root || document).querySelectorAll('[data-ham-reveal]:not(.ham-in):not(.ham-pre)');
    if (!items.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ham-in');
          entry.target.classList.remove('ham-pre');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) return;
      el.classList.add('ham-pre');
      io.observe(el);
    });
  }

  /* Mobile menu: close on Escape or after choosing a link */
  function setupMenu() {
    document.querySelectorAll('[data-ham-menu]').forEach(function (menu) {
      menu.addEventListener('click', function (e) {
        if (e.target.closest('a')) menu.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-ham-menu][open]').forEach(function (menu) {
        menu.removeAttribute('open');
        var summary = menu.querySelector('summary');
        if (summary) summary.focus();
      });
    });
  }

  function init() {
    setupReveal();
    setupMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
